import { Save } from "lucide-react";
import { L, cls, statusOptions } from "./servicesShared";

// hizmet başlığı ekle / düzenle
export default function CategoryForm({ form, setForm, onSubmit, onCancel }) {
  return (
    <form onSubmit={onSubmit} className="bg-white border border-slate-200 rounded-md p-4 flex items-end gap-3 flex-wrap" data-testid="cat-form">
      <L label="Başlık Adı"><input required data-testid="cat-field-name" value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} className={cls} placeholder="örn. Ekstra Temizlik" /></L>
      <L label="Durum">
        <select value={form.status} onChange={(e) => setForm({ ...form, status: e.target.value })} className={cls}>
          {statusOptions.map((o) => <option key={o.value} value={o.value}>{o.label}</option>)}
        </select>
      </L>
      <div className="flex gap-2">
        <button type="submit" data-testid="cat-save" className="inline-flex items-center gap-1.5 px-3 py-2 rounded-md bg-slate-900 text-white text-xs font-semibold hover:bg-slate-800"><Save className="w-3.5 h-3.5" /> Kaydet</button>
        <button type="button" onClick={onCancel} className="px-3 py-2 text-xs text-slate-600 hover:text-slate-900">İptal</button>
      </div>
    </form>
  );
}
